import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {DatePicker} from "~/components/forms/date-picker";
import {isDefined} from "~/lib/helpers/guards";
import {toDateTime} from "~/lib/helpers/date";
import {DateTime} from 'luxon';
import {getNullTimePickerData, TimePicker, TimePickerData} from "~/components/forms/time-picker";

// What if date is null ?

@Component
export class DateTimePicker extends Vue {

  @Prop({type: [Date, null], default: null}) value: Date;
  @Prop({type: Boolean, default: true}) showTime: boolean;

  protected date: DateTime = null;
  protected time: TimePickerData = getNullTimePickerData();

  @Watch("value", {immediate: true, deep: true})
  transformValue(next) {
    if (isDefined(next)) {
      let base = toDateTime(this.value);
      this.date = DateTime.fromObject({year: base.year, month: base.month, day: base.day}).toJSDate();
      this.time = {HH: padLeft(base.hour), mm: padLeft(base.minute)};
    } else {
      this.clear();
    }
  }

  clear(){
    this.time = getNullTimePickerData();
    this.date = null;
  }

  reset(){
    this.clear();
    this.emit();
  }

  setDate(v) {
    if( !isDefined(v)) {
      this.reset();
    } else {
      let base = toDateTime(v);
      this.date = DateTime.fromObject({year: base.year, month: base.month, day: base.day}).toJSDate();
    }
    this.emit();
  }

  setTime(v) {
    this.time = v;
    this.emit();
  }

  emit() {
    let output = null;
    if (isDefined(this.date)) {
      output = toDateTime(this.date);
      if( isValidTime(this.time)) {
        output = output.set({hour: this.time.HH, minute: this.time.mm});
      }
      output = output.toJSDate();
    }

    this.$emit("input",output);
  }

  render() {
    return (
      <div class="datetime-picker">
        <DatePicker value={this.date} onInput={this.setDate} showClearButton={false}/>
        {this.showTime && <TimePicker value={this.time} onInput={this.setTime} showClearButton={false}/>}
        <button class="button is-small" onClick={this.reset}>Effacer</button>
      </div>
    );
  }
}

function isValidTime(x: TimePickerData) {
  return isDefined(x) && isDefined(x.HH) && x.HH.length > 0 && isDefined(x.mm) && x.mm.length > 0;
}

function padLeft(value: unknown) {
  let asString = `${value}`;
  return asString.length === 1 ? `0${asString}` : asString;
}

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-058eac6c/datetime-picker.tsx" });